const features = [
  {
    icon: 'ri-flashlight-line',
    title: '极速更新',
    desc: '全天候追踪全网热点，最新吃瓜视频和黑料爆料第一时间上线，让你永远快人一步掌握热门动态。',
  },
  {
    icon: 'ri-stack-line',
    title: '海量资源',
    desc: '汇聚超10,000条吃瓜视频资源，覆盖网红爆料、娱乐圈黑料、社会现场实拍等多元品类，一站看全。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '真实可靠',
    desc: '坚持原生态吃瓜内容，拒绝虚假炒作，每一条爆料视频和黑料信息都经过多方核实后发布。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-900">
            平台特色
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {features.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 border border-background-200/70 rounded-xl p-6 md:p-8 hover:border-primary-200/60 transition-colors cursor-pointer group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading font-bold text-lg text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}